module.exports = __webpack_public_path__ + "img/CABIN-DECORATION.6235c92f.jpg";